import { useState, useEffect } from "react";
import {
  DisplayFlexHome,
} from "./styled";


import Tarefas from "../../components/PortalHome/Modal/Tarefas";
import OrdensServico from "../../components/PortalHome/Modal/OrdensDeServiço";
import AlvarasLicenca from "../../components/PortalHome/Modal/AlvarasLicencas";
import Atendimentos from "../../components/PortalHome/Modal/Atendimentos";
import { ApontamentosDp } from "../../components/PortalHome/Modal/ApontamentosDp";
import ApontamentosFiscais from "../../components/PortalHome/Modal/ApontamentosFiscais";
import { CiBank, CiCircleList, CiFileOn, CiMemoPad, CiReceipt, CiViewTimeline } from "react-icons/ci";

function PageHome() {
  const [cardsFilter, setCardsFilter] = useState([]);
  const [selectedItemId, setSelectedItemId] = useState(1);
  const [selectedFilter, setSelectedFilter] = useState(1);
  const [perfilLocalStorage, setPerfilLocalStorage] = useState([]);
  const [isParalegal, setIsParalegal] = useState(false);


  useEffect(() => {
    const dadosSession = sessionStorage.getItem("USER");

    if (dadosSession && dadosSession !== "false") {
      try {
        const dadosConvertidos = JSON.parse(dadosSession);
        setPerfilLocalStorage(dadosConvertidos);

        // Verifica se é admin
        const temPerfilParalegal = dadosConvertidos.perfis?.some(perfil => perfil.id === "GRP_PORTAL_PARALEGAL");
        setIsParalegal(temPerfilParalegal);

        // Se for admin, já seta o filtro selecionado
        if (temPerfilParalegal) {
          setSelectedFilter(2);
          setSelectedItemId(2);
        } else {
          setSelectedFilter(1);
          setSelectedItemId(1);
        }

      } catch (erro) {
        console.error("Erro ao fazer o parse do sessionStorage:", erro);
      }
    } else {
      console.warn("SessionStorage vazio ou inválido");
    }
  }, []);

  const filtros = [
    { "id": 1, "icon": <CiViewTimeline />, "nome": "Tarefas" },
    { "id": 2, "icon": <CiMemoPad />, "nome": "Ordens de serviço" },
    { "id": 3, "icon": <CiReceipt />, "nome": "Alvarás e licenças" },
    { "id": 4, "icon": <CiCircleList />, "nome": "Atendimentos" },
    { "id": 5, "icon": <CiFileOn />, "nome": "Apontamentos DP" },
    { "id": 6, "icon": <CiBank />, "nome": "Apontamentos fiscais" }
  ]


  useEffect(() => {
    setCardsFilter(filtros);
  }, []);


  const ServiceExchange = (id) => {
    setSelectedFilter(id);
    setSelectedItemId(id);
  };

  return (
    <>
      <DisplayFlexHome>
        <div className="modal-container">
          <div className="center-fixed">


            <div className="display-filter">
              {cardsFilter.map((item) => (
                <div
                  key={item.id} // Use o id do item em vez do index para melhor performance
                  onClick={() => ServiceExchange(item.id)}
                  className={`btn-home ${selectedItemId === item.id ? "selected" : "bg-padrao"}`}
                >
                  <span>{item.nome}</span>
                </div>
              ))}
            </div>

            {selectedFilter === 1 && <Tarefas />}
            {selectedFilter === 2 && <OrdensServico />}
            {selectedFilter === 3 && <AlvarasLicenca />}
            {selectedFilter === 4 && <Atendimentos />}
            {selectedFilter === 5 && <ApontamentosDp />}
            {selectedFilter === 6 && <ApontamentosFiscais />}
          </div>
        </div>
      </DisplayFlexHome>
    </>

  );
}
export default PageHome;
